<template>
  <div :class="'word-preview word-theme-' + theme">
    <ImageView :src="entity.image" v-if="entity.image"></ImageView>
    <pinyin :text="entity.text" :pinyin="entity.pinyin"></pinyin>
    <AudioView :src="entity.audio" v-if="entity.audio"></AudioView>
  </div>
</template>

<script>
import pinyin from './../PinyinPreview'
import ImageView from './../ImageView'
import AudioView from './../AudioView'

export default {
  name: 'WordPreview',
  components: { pinyin, ImageView, AudioView },
  props: {
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'card'
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">
  .word-theme-line{
    display: flex;
    align-items: center;
    > div + div {
      margin-left: 5px;
    }
    img{
      max-height: 50px;
    }
  }
</style>
